var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppGreyV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.22 28.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #d1d3d4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -3.78,
    y: 4.78,
    width: 27.79,
    height: 19.22,
    rx: 2.02,
    ry: 2.02,
    transform: "translate(24.5 4.28) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.7,28.79H2.52c-1.39,0-2.52-1.13-2.52-2.52V2.52C0,1.13,1.13,0,2.52,0h15.18c1.39,0,2.52,1.13,2.52,2.52v23.75c0,1.39-1.13,2.52-2.52,2.52ZM2.52,1c-.84,0-1.52.68-1.52,1.52v23.75c0,.84.68,1.52,1.52,1.52h15.18c.84,0,1.52-.68,1.52-1.52V2.52c0-.84-.68-1.52-1.52-1.52H2.52Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10.11,
    cy: 25.35,
    r: 1.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.11,26.89c-.85,0-1.54-.69-1.54-1.54s.69-1.54,1.54-1.54,1.54.69,1.54,1.54-.69,1.54-1.54,1.54ZM10.11,24.81c-.3,0-.54.24-.54.54s.24.54.54.54.54-.24.54-.54-.24-.54-.54-.54Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.01,
    y: 4.48,
    width: 4.04,
    height: 4.04,
    rx: 1.17,
    ry: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.09,
    y: 4.48,
    width: 4.04,
    height: 4.04,
    rx: 1.17,
    ry: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 13.17,
    y: 4.48,
    width: 4.04,
    height: 4.04,
    rx: 1.17,
    ry: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.01,
    y: 9.66,
    width: 4.04,
    height: 4.04,
    rx: 1.17,
    ry: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.09,
    y: 9.66,
    width: 4.04,
    height: 4.04,
    rx: 1.17,
    ry: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 13.17,
    y: 9.66,
    width: 4.04,
    height: 4.04,
    rx: 1.17,
    ry: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.01,
    y: 15.47,
    width: 4.04,
    height: 4.04,
    rx: 1.17,
    ry: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.09,
    y: 15.47,
    width: 4.04,
    height: 4.04,
    rx: 1.17,
    ry: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 13.17,
    y: 15.47,
    width: 4.04,
    height: 4.04,
    rx: 1.17,
    ry: 1.17
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppGreyV2);
export default __webpack_public_path__ + "static/media/App - Grey V2.d9027a4657a9f96b47b8572af97e9818.svg";
export { ForwardRef as ReactComponent };